<template>
  <div>
    <div class="left-box">
      <div class="left-title">本学期各学院跑步公里数统计</div>
      <div class="echarts" style="height: 306px">
        <div
          id="month1"
          :style="{
            width: '490px',
            height: '318px',
            margin: '0 auto',
          }"
        ></div>
      </div>
    </div>
    <div class="left-box" style="margin-top: 24px">
      <div class="left-title">本学期各学院锻炼人次统计</div>
      <div class="echarts" style="height: 306px">
        <div
          id="month2"
          :style="{
            width: '490px',
            height: '318px',
            margin: '0 auto',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['semesterDataNew'],
  data() {
    return {
      echartsData: '',
      option1: {},
      option2: {},
      sData: {},
    }
  },
  //   watch: {
  //     semesterDataNew: {
  //       handler: function () {
  //         console.log('change?????')
  //         // this.option1.series[0].data = newVal
  //         var myChart1 = this.$echarts.init(document.getElementById('month1'))
  //         myChart1.setOption(this.option1)
  //         var myChart2 = this.$echarts.init(document.getElementById('month2'))
  //         myChart2.setOption(this.option2)
  //       },
  //       deep: true,
  //     },
  //   },
  mounted() {
    // this.drawMonthData()
    // this.firstPic()
    window.onresize = () => {
      return (() => {
        this.drawMonthData()
        this.firstPic()
      })()
    }
  },
  computed: {},
  methods: {
    refresh(data) {
      console.log('refresh??')
      this.sData = data
      this.drawMonthData()
      this.firstPic()
      //   var myChart1 = this.$echarts.init(document.getElementById('month1'))
      //   myChart1.setOption(this.option1)
      //   var myChart2 = this.$echarts.init(document.getElementById('month2'))
      //   myChart2.setOption(this.option2)
    },
    firstPic() {
      console.log('firstPic?????')
      var myChart1 = this.$echarts.init(document.getElementById('month1'))
      this.option1 = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        toolbox: {
          //   feature: {
          //     dataView: { show: true, readOnly: false },
          //     magicType: { show: true, type: ['line', 'bar'] },
          //     restore: { show: true },
          //     saveAsImage: { show: true },
          //   },
        },
        legend: {
          data: [
            {
              name: '总公里数',
              textStyle: {
                color: '#339571',
              },
            },
            {
              name: '人均公里数',
              textStyle: {
                color: '#FFB612',
              },
            },
          ],
        },
        xAxis: [
          {
            type: 'category',
            // data: ['计算', '人文', '商学院', '医学院', '传媒', '信电', '土木'],
            data: this.sData.college,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              // formatter: function (value) {
              //   if (value.length > 4) {
              //     return value.slice(0, 3) + '...'
              //   }
              //   return value
              // },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            // name: 'Precipitation',
            // min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value} ',
            },
          },
          {
            type: 'value',
            // name: 'Temperature',
            // min: 0,
            // max: 25,
            // interval: 10,
            axisLabel: {
              formatter: '{value} ',
            },
          },
        ],
        series: [
          {
            name: '总公里数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + 'km '
              },
            },
            // data: [
            //   2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4,
            //   3.3,
            // ],
            data: this.sData.sumDistance,
            itemStyle: {
              color: '#339571',
            },
          },

          {
            name: '人均公里数',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' km/人'
              },
            },
            data: this.sData.perCaitaKm,
            itemStyle: {
              color: '#FFB612',
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
    drawMonthData() {
      console.log('drawMonthData?????')
      var myChart2 = this.$echarts.init(document.getElementById('month2'))
      this.option2 = {
        legend: {
          data: [
            {
              name: '锻炼总人次',
              textStyle: {
                color: '#339571',
              },
            },
            {
              name: '人均锻炼次数',
              textStyle: {
                color: '#FFB612',
              },
            },
          ],
          //   right: '10%',
          //   top: '16',
          //   itemHeight: 8,
          //   itemWidth: 8,
          //   textStyle: {
          //     color: '#ffffff66',
          //   },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          //   data: this.monthColleges,

          //   data: ['计算', '人文', '商学院', '医学院', '传媒', '信电', '土木'],
          data: this.sData.college,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: [
          {
            minInterval: 50,
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.2)',
              },
            },
          },
          {
            minInterval: 1,
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.2)',
              },
            },
            axisLabel: {
              formatter: '{value} 次',
            },
          },
        ],
        series: [
          {
            name: '锻炼总人次',
            type: 'bar',
            stack: 'one',
            // data: [100, 110, 80, 90, 110, 160, 100],
            data: this.sData.runCount,
            itemStyle: {
              //   color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     { offset: 0, color: '#FFB612' },
              //     { offset: 1, color: '#4DA282' },
              //   ]),
              color: '#339571',
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + '次'
              },
            },
          },
          {
            name: '人均锻炼次数',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '次'
              },
            },
            data: this.sData.perExerciseNums,
            itemStyle: {
              color: '#FFB612',
            },
          },
        ],
      }
      myChart2.setOption(this.option2)
    },
  },
}
</script>
<style scoped lang="scss">
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;

  //   margin-top: 16px;

  .left-title {
    // font-size: 0.5rem;
    font-size: 22px;
    margin-bottom: 8px;
    // margin-left: 24px;
  }
}
.echarts {
  //   width: calc(100% - 48px);
  //   background: linear-gradient(
  //     180deg,
  //     rgba(26, 135, 95, 0.15) 0%,
  //     rgba(0, 122, 77, 0.24) 100%
  //   );
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
  padding: 0 16px;
  //   margin-left: 24px;
  //   height: calc(34vh - 46px);
}
</style>
